<div class="grid-6 copo-container footer-margin" *ngIf="segment && segment.erichsenList && this.segment.erichsenList.length > 0">
	<div class="grid-column-one-full">
		<mat-expansion-panel [expanded]="true" class="card-info-block">
			<mat-expansion-panel-header>
				<mat-panel-title class="card-content-title">
					<span translate>aqdb.mechanical.characteristics.erichsen</span>
				</mat-panel-title>
			</mat-expansion-panel-header>
			<mat-divider class="margin-expansion-panel"></mat-divider>
			<div class="card-content-block quadruple-column" *ngFor="let erichsen of segment.erichsenList">
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.test.number.erichsen</div>
						<div class="card-content-value">{{ erichsen.number !== null && erichsen.number !== undefined ? (erichsen.number | copoNumber:'number') : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.anisotropy.direction</div>
						<div class="card-content-value">{{ erichsen.direction ? erichsen.direction : UNDERSCORE }}</div>
					</div>
				</div>
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.pos.across.width</div>
						<div class="card-content-value">{{ erichsen.widthPosition ? erichsen.widthPosition : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.pos.across.length</div>
						<div class="card-content-value">{{ erichsen.lengthPosition !== null && erichsen.lengthPosition !== undefined ? (erichsen.lengthPosition | copoNumber:'weight') : UNDERSCORE }} </div>
					</div>
				</div>
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.steel.condition</div>
						<div class="card-content-value">{{ erichsen.stateMetalUnit ? erichsen.stateMetalUnit : UNDERSCORE }} </div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.erichsen.index</div>
						<div class="card-content-value">{{ erichsen.erichsenIndex && isDisplayedData(erichsen.indTrsErichsen) ? (erichsen.erichsenIndex | copoNumber:'weight') : UNDERSCORE }}
							<span *ngIf="isTransmittedOnCertificateData(erichsen.indTrsErichsen)" class="transmitted-data-icon"><mat-icon [matTooltip]="'aqdb.datas.transmitted.on.certificate' | translate" color="accent" class="batch-icon" svgIcon="icon-transmitted"></mat-icon></span>
							<span *ngIf="isMeasuredData(erichsen.indTrsErichsen, erichsen.erichsenIndexTypdon)"><mat-icon [matTooltip]="'aqdb.measured.datas' | translate" color="accent" class="batch-icon" svgIcon="icon-measured"></mat-icon></span>
							<span *ngIf="isModelledData(erichsen.indTrsErichsen, erichsen.erichsenIndexTypdon)"><mat-icon  [matTooltip]="'aqdb.modelled.data' | translate" color="accent" class="batch-icon" svgIcon="icon-modelled"></mat-icon></span>
						</div>
					</div>
				</div>
			</div>
		</mat-expansion-panel>
	</div>
</div>
